import { z } from "zod";
export const MUNICIPAL_PROPERTY_CONSUMPTION_IMPORT_MAX_PROPERTIES = 2500;
export const MUNICIPAL_PROPERTY_CONSUMPTION_IMPORT_MAX_BYTES = 16 * 1024 * 1024;
export const MUNICIPAL_PROPERTY_CONSUMPTION_IMPORT_ROW_SCHEMA = z.object({
    fileRow: z.number().int().min(2).max(MUNICIPAL_PROPERTY_CONSUMPTION_IMPORT_MAX_BYTES).optional(),
    inventoryId: z.string().min(1).max(100), year: z.string().min(1).max(4),
    propertyYearId: z.string().min(1).max(100), name: z.string().max(1000),
    energySourceKey: z.string().min(1).max(100), unit: z.string().min(1).max(10),
    amount: z.string().max(1000), proof: z.string().min(1).max(64),
});
export const MUNICIPAL_PROPERTY_CONSUMPTION_IMPORT_FIELD_LIST = MUNICIPAL_PROPERTY_CONSUMPTION_IMPORT_ROW_SCHEMA.omit({ fileRow: true }).keyof().options;
const ERROR_CODE_LIST = [
    "wrongYear", "wrongUnit", "negativeAmount", "invalidAmount", "duplicate", "invalidTemplate",
];
const PREVIEW_STATUS_LIST = ["new", "changed", "delete", "unchanged", "invalid"];
const PREVIEW_ROW_SCHEMA = z.object({
    fileRow: z.number().int().min(2),
    inputAmount: z.string(),
    inputYear: z.string(),
    inputUnit: z.string(),
    expectedYear: z.string(),
    expectedUnit: z.string().nullable(),
    errorCode: z.enum(ERROR_CODE_LIST).nullable(),
    name: z.string(),
    energySourceKey: z.string(),
    amount: z.number().finite().nullable(),
    previousAmount: z.number().finite().nullable(),
    status: z.enum(PREVIEW_STATUS_LIST),
});
const MANUAL_CONFLICT_SCHEMA = z.object({
    id: z.string(),
    inventoryId: z.string(),
    inventoryName: z.string(),
    year: z.number().int(),
    sectorId: z.string(),
    subsectorId: z.string(),
    energySourceId: z.string(),
    previousAmount: z.number().finite(),
    projectedAmount: z.number().finite(),
    notationKey: z.string().nullable(),
});
export const MUNICIPAL_PROPERTY_CONSUMPTION_IMPORT_PREVIEW_SCHEMA = z.object({
    fingerprint: z.string(),
    rowList: z.array(PREVIEW_ROW_SCHEMA),
    affectedInventoryList: z.array(z.object({ id: z.string(), title: z.string() })),
    hasHiddenInventory: z.boolean(),
    manualConflictList: z.array(MANUAL_CONFLICT_SCHEMA),
    hasHiddenManualConflict: z.boolean(),
    canOverwriteManualConflict: z.boolean(),
});
